import { PermissionsService } from './../services/auth/permissions.service';
import { DatasetsService } from '@services/datasets/datasets.service';
import { Directive, HostListener, Input, Output, EventEmitter } from '@angular/core';
import { SimulationRunnerService } from '@services/simulation-set/simulation-runner.service';
import { SimulationSetService } from '@services/simulation-set/simulation-set.service';
import { ResultTabsService } from '@services/results/result-tabs.service';
import { ResultsService } from '@services/results/results.service';

@Directive({
  selector: '[appRunSimulation]',
  exportAs: 'appRunSimulation'
})
export class RunSimulationDirective {
  @Input() isARerun = false;
  @Output() canCloseDialog = new EventEmitter();
  public isRunningSimulation = false;

  constructor(
    private simService: SimulationSetService,
    private simRunner: SimulationRunnerService,
    private resultTabs: ResultTabsService,
    private datasetService: DatasetsService,
    private resultsService: ResultsService,
    private permissions: PermissionsService
  ) {}

  @HostListener('click') onClick() {
    this.isRunningSimulation = true;
    this.resultsService
      .getResultSetIdentifiers()
      .toPromise()
      .then(_ => {
        if (this.isARerun) {
          const activeTabName = this.resultTabs.activeView.tabName;
          this.simRunner.rerunSimulation(activeTabName);
        } else {
          this.simService.runSimulation();
        }
        this.canCloseDialog.emit(true);
      });
  }

  public get isValidSimulationSet() {
    return (
      this.simService.isValidSimulationSet &&
      !this.datasetService.isImportRequired &&
      this.permissions.getPermission('RunSimulation') === 'W'
    );
  }
}
